// BETA-53 ("Agregar dispositivo"): the single entry point the ticket asks
// for. Before this, connecting a device from a template and connecting one
// from scratch were two separate buttons on I/O & connections, each opening
// its own dialog. This is the first of the wizard's screens: pick a path,
// then EdgeConnectorsModal drives the rest through the exact same
// DeviceTemplatesModal / EdgeConnectorCreateForm it already used — neither
// changes. Per docs/battex/beta/PROPOSAL-13-tag-setup.md §6.1, "no template"
// still means manual, register by register; this screen only chooses which
// existing flow to enter.
import React from "react";

import xmarkIcon from "../../../assets/xmark.svg";

export default function AddDeviceChooser({ onPickTemplate, onNoTemplate, onClose }) {
  return (
    <div className="gwOverlay" style={{ zIndex: 115 }}>
      <div className="gwModal" role="dialog" aria-modal="true" aria-labelledby="add-device-title">
        <div className="gwModalHeader">
          <div>
            <div className="gwModalTitle" id="add-device-title">Add device</div>
            <div className="gwModalSubtitle">Connect a device from a saved template, or start from scratch.</div>
          </div>
          <button type="button" className="gwModalClose" onClick={onClose} aria-label="Close">
            <img src={xmarkIcon} alt="" className="gwIcon" />
          </button>
        </div>
        <div className="gwModalBody">
          <div className="gwEdgeProgramRow">
            <div className="gwEdgeProgramMain">
              <div className="gwListTitle">From a saved template</div>
              <div className="gwListMeta">
                Pick the model (e.g. a Solis inverter), give it a host and address — every register is
                already defined.
              </div>
            </div>
            <div className="gwRowActions">
              <button type="button" className="gwPrimaryBtn" onClick={onPickTemplate}>Choose template</button>
            </div>
          </div>
          <div className="gwEdgeProgramRow">
            <div className="gwEdgeProgramMain">
              <div className="gwListTitle">No template</div>
              <div className="gwListMeta">Build the connection register by register, same as today.</div>
            </div>
            <div className="gwRowActions">
              <button type="button" className="gwSecondaryBtn" onClick={onNoTemplate}>Continue without a template</button>
            </div>
          </div>
        </div>
        <div className="gwModalFooter" style={{ justifyContent: "flex-end" }}>
          <button type="button" className="gwGhostBtn" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
}
